import _classCallCheck from "C:\\Users\\dell\\Downloads\\Projects\\fezile-fashion-skills-academy\\site\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\dell\\Downloads\\Projects\\fezile-fashion-skills-academy\\site\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _inherits from "C:\\Users\\dell\\Downloads\\Projects\\fezile-fashion-skills-academy\\site\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _createSuper from "C:\\Users\\dell\\Downloads\\Projects\\fezile-fashion-skills-academy\\site\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createSuper";
import * as React from 'react';
import * as ReactDOM from 'react-dom';
/**
 * This component wraps any ReactNode and finds its ref
 * It has to be a class for findDOMNode to work
 * Ideally, all components used as triggers/toggles are either:
 * - class based components we can assign our own ref to
 * - functional components that have forwardRef implemented
 * However, there is no guarantee that is what will get passed in as trigger/toggle in the case of tooltips and popovers
 */
export var FindRefWrapper = /*#__PURE__*/function (_React$Component) {
  _inherits(FindRefWrapper, _React$Component);
  var _super = _createSuper(FindRefWrapper);
  function FindRefWrapper() {
    _classCallCheck(this, FindRefWrapper);
    return _super.apply(this, arguments);
  }
  _createClass(FindRefWrapper, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // eslint-disable-next-line react/no-find-dom-node
      var root = ReactDOM.findDOMNode(this);
      this.props.onFoundRef(root);
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children || null;
    }
  }]);
  return FindRefWrapper;
}(React.Component);
FindRefWrapper.displayName = 'FindRefWrapper';